import { gemmiciApiServiceClient } from "../../core/apis/gemmiciApiService/AxiosIntance";

export default {
  get() {
    return gemmiciApiServiceClient.get("/organization_users/me");
  }
}